export default function Footer() {
  return (
    <footer className="bg-dark text-white-50 py-4">
      <div className="container text-center">
        <p className="mb-0">© 2026 Помощь 24/7. Все права защищены.</p>
        <p className="mt-2 small">
          <p className="text-white-50 text-decoration-none hover:text-white">
            Da_Vinchi Devs
          </p>
        </p>
      </div>
    </footer>
  );
}